module.exports = __webpack_public_path__ + "assets/img/3edc0404079cc82e38cd0eb45dba14fd.svg";